module.exports = __webpack_public_path__ + "img/15.68839630.jpg";